<template>
  <v-container class="px-8">
    <div class="py-3 pl-2 flex-grow-0 flex-shrink-0">
      <div class="d-flex flex-row justify-space-between align-end">
        <div class="text-h4 font-weight-medium">
          {{ $t("navbar.menu.cities") }}
        </div>
      </div>
    </div>
    <v-card>
      <v-card-text>
        <input
          type="file"
          style="display: none"
          ref="image"
          accept="image/*"
          @change="onFilePicked"
        />
        <v-row>
          <v-col cols="12">
            <div class="d-flex">
              <CitiesAutocomplete
                ref="autocomplete"
                style="max-width: 300px"
                @selected-city="citySelected($event)"
              />
              <!-- </div> -->
              <!-- <div v-if="selectedCity" class="d-flex flex-row"> -->
              <div class="d-flex" v-if="selectedCity">
                <DatePickerField
                  v-model="selectedCity.arrival_date"
                  :label="$t('NewTrip.arrivalDate')"
                />
                <DatePickerField
                  v-model="selectedCity.departure_date"
                  :label="$t('NewTrip.departureDate')"
                />

                <v-btn class="mt-3 ml-4" color="primary" :loading="isLoading" @click="addCity"
                  >{{ $t("cities.addCity") }}
                </v-btn>
              </div>
            </div>
            <p v-if="cityFeedback" class="error--text">
              {{ cityFeedback }}
            </p>
          </v-col>
          <v-card-title v-if="Object.keys(cities).length == 0">
            {{ $t("cities.noCities") }}
          </v-card-title>

          <v-col v-for="(city, index) in cities" :key="city.id" cols="6" md="4">
            <v-card>
              <v-img
                :src="city.image"
                :class="`${city.image ? 'white--text' : ''} grey lighten-3`"
                height="200px"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              >
                <v-card-title class="fill-height align-end">{{ city.name }}</v-card-title>
              </v-img>
              <v-card-text>
                <div>
                  <v-icon>mdi-calendar</v-icon>
                  {{ city.arrival_date | strToDate("P") }}
                  <v-icon>mdi-calendar-arrow-right</v-icon>
                  {{ city.departure_date | strToDate("P") }}
                </div>
              </v-card-text>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-checkbox
                  :input-value="findMap(city.name)"
                  class="mx-2"
                  color="primary"
                  :label="$t('cities.offlineMap')"
                  @change="toggleOfflineMap($event, city)"
                ></v-checkbox>
                <v-btn icon @click="selectFile(index)">
                  <v-icon>mdi-camera</v-icon>
                </v-btn>

                <v-btn icon @click.stop="showDeleteDialog(city)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>

                <!-- <div class="text-center"> -->

                <!-- </div> -->
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-snackbar v-model="snackbar">
          {{ $t("cities.imageSave") }}
          <v-btn color="primary" text @click="snackbar = false">{{ $t("common.close") }}</v-btn>
        </v-snackbar>

        <v-dialog v-model="dialog" width="300">
          <v-card v-if="cityToDelete">
            <v-card-title class="headline lighten-2">{{ $t("cities.deleteCity") }}</v-card-title>
            <v-card-text>{{ $t("common.delete") }} {{ cityToDelete.name }}</v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn color="primary" text @click="closeDialog">{{ $t("common.cancel") }}</v-btn>
              <v-btn color="error" @click="deleteCity">{{ $t("common.delete") }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import firestore from "@/firebase/firestore";
import DatePickerField from "@/components/Base/DatePickerField";
import storage from "@/firebase/storage";
import mbApi from "@/APIS/mapbox-api";
import _ from "lodash";
import { uuid } from "vue-uuid";
import moment from "moment-timezone";
import CitiesAutocomplete from "./CitiesAutocomplete";

export default {
  name: "Cities",
  components: {
    CitiesAutocomplete,
    DatePickerField,
  },
  data: () => ({
    dialog: false,
    photoCityIndex: null,
    snackbar: false,
    newCity: "",
    selectedCity: null,
    isLoading: false,
    cityToDelete: null,
    cityFeedback: null,
  }),
  computed: {
    cities() {
      return Object.values(this.$store.state.trip.cities).sort((a, b) => {
        if (!a.arrival_date || !b.arrival_date) return 0;
        return a.arrival_date < b.arrival_date ? -1 : 1;
      });
    },
  },
  methods: {
    showDeleteDialog(city) {
      this.dialog = true;
      this.cityToDelete = city;
    },
    closeDialog() {
      this.dialog = false;
      this.cityToDelete = null;
    },
    findMap(name) {
      const { maps } = this.$store.state.trip;
      return _.findKey(maps, (map) => map.name === name);
    },
    toggleOfflineMap(value, city) {
      const tripId = this.$store.getters.currentTripId;
      if (value) {
        const map = {
          name: city.name,
          map_area: {
            from_zoom: 2,
            to_zoom: 14,
            north_east: city.north_east,
            south_west: city.south_west,
          },
        };
        firestore.writeTrackedDocument(tripId, "maps", map);
      } else {
        const map = this.findMap(city.name);
        if (map) {
          firestore.deleteDocument(tripId, "maps", map);
        }
      }
    },
    deleteCity() {
      const city = this.cityToDelete;
      if (city == null) {
        return;
      }
      this.closeDialog();
      const tripId = this.$store.getters.currentTripId;
      firestore.deleteDocument(tripId, "cities", city.id);
      const map = this.findMap(city.name);
      if (map) {
        firestore.deleteDocument(tripId, "maps", map);
      }
    },
    citySelected(city) {
      const tripStart = moment(this.$store.state.trip.trip.start_date.toDate())
        .tz("UTC")
        .format("YYYY-MM-DD");

      this.selectedCity = { ...city, arrival_date: tripStart, departure_date: tripStart };
    },
    addCity() {
      if (!this.selectedCity.arrival_date || !this.selectedCity.departure_date) {
        this.cityFeedback = this.$t("cities.datesFeedback");
        return;
      }
      this.isLoading = true;
      const tripId = this.$store.getters.currentTripId;
      mbApi.createCity(this.selectedCity).then((city) => {
        this.$refs.autocomplete.clearTextfield();
        this.isLoading = false;
        console.log(city);
        console.log(this.selectedCity);
        firestore.writeCity(tripId, "cities", this.selectedCity.properties.name, city);
        this.selectedCity = null;
      });
    },
    onFilePicked(e) {
      const { files } = e.target;
      if (this.photoCityIndex != null && files[0] !== undefined) {
        const file = files[0];
        const tripId = this.$store.getters.currentTripId;
        if (tripId) {
          // const fr = new FileReader();
          // fr.readAsDataURL(files[0]);
          // fr.addEventListener("load", () => {
          const name = `${uuid.v4()}.${file.name.split(".").pop().toLowerCase()}`;
          const firPath = `groups/${tripId}/images/${name}`;
          storage.uploadFile(file, firPath).then((snapshot) => {
            snapshot.ref.getDownloadURL().then((url) => {
              const city = { ...this.cities[this.photoCityIndex] };
              city.image = url;
              const cityId = city.id;
              delete city.id;
              firestore.writeDocument(tripId, "cities", city, cityId, {
                "files.header": firPath,
              });
              this.snackbar = true;
            });
          });
        }
        // });
      }
    },
    selectFile(index) {
      this.photoCityIndex = index;
      this.$refs.image.click();
    },
  },
};
</script>
